import React from "react";
import { User } from "../../../api/usersApi";
import { ConfirmationDialog } from "../../../components/common/ConfirmationDialog/ConfirmationDialog";

interface DeleteUserDialogProps {
  open: boolean;
  user: User | null;
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
}

const DeleteUserDialog: React.FC<DeleteUserDialogProps> = ({
  open,
  user,
  onClose,
  onConfirm,
  isLoading,
}) => {
  return (
    <ConfirmationDialog
      open={open}
      title="Delete User"
      message={`Are you sure you want to delete the user "${user?.firstName} ${user?.lastName}"? This action cannot be undone.`}
      confirmLabel="Delete"
      confirmColor="error"
      onClose={onClose}
      onConfirm={onConfirm}
      isLoading={isLoading}
    />
  );
};

export default DeleteUserDialog;
